import NiceModal from "@ebay/nice-modal-react";
import { Box, ButtonProps } from "@mui/material";
import { StepperType, SupportedContractType } from "@repo/logic";
import { FC, useCallback } from "react";
import { Icons } from "../..";
import { useTypedTranslation } from "../../../hooks/useTypedTranslation";
import { ButtonWithIconRight } from "../../ButtonWithIconRight";
import * as Styled from "./PensionQuestionnaireStepperButton.styled";

type PensionQuestionnaireStepperButtonProps = {
    buttonProps: ButtonProps;
    type?: "detail" | "homePage";
    contractId: string;
    contractType?: SupportedContractType;
};

export const PensionQuestionnaireStepperButton: FC<PensionQuestionnaireStepperButtonProps> = ({
    buttonProps = { disabled: false, title: "" },
    type = "detail",
    contractId,
    contractType,
}) => {
    const handleShowStepper = useCallback(
        (title?: string, name?: StepperType) => {
            NiceModal.show("Nicemodal-PensionQuestionnaireStepperModal", {
                additionalContentProps: {
                    contractId: contractId,
                    contractType: contractType,
                    type: type,
                    title,
                    name,
                },
            });
        },
        [contractId, contractType, type],
    );

    const { t } = useTypedTranslation();

    return (
        <>
            {/* Změna investiční strategie - na detailu */}
            {type === "detail" && (
                <Box>
                    <Styled.ChangeSavingsStrategyButton
                        variant="contained"
                        disabled={buttonProps.disabled}
                        onClick={() =>
                            handleShowStepper(
                                t("investmentStrategy.changeSavingsStrategy"),
                                StepperType.ChangeInvestmentStrategy,
                            )
                        }
                    >
                        {buttonProps.title}
                    </Styled.ChangeSavingsStrategyButton>
                </Box>
            )}
            {/* Změna potřeb - smart action na homepage */}
            {type === "homePage" && (
                <ButtonWithIconRight
                    {...buttonProps}
                    icon={<Icons.UmbrellaPig />}
                    onClick={() =>
                        handleShowStepper(
                            t("investmentStrategy.toChangePensionQuestionnaire"),
                            StepperType.PensionQuestionnaire,
                        )
                    }
                    title={t("SmartActionsButtons.PensionQuestionnaireTitle")}
                    subtitle={t("SmartActionsButtons.PensionQuestionnaireSubtitle")}
                />
            )}
        </>
    );
};
